import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from "@angular/core";
import { ServicioGeneral } from "src/app/_services/servicio-general.service";
import { TokenStorageService } from "src/app/_services/token-storage.service";
import jwt_decode from "jwt-decode";
import {  Router } from "@angular/router";
import { NotificationService } from "src/app/_services/notification.service";
import { NgxSpinnerService } from "ngx-spinner";
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
import { ClientLoaderService } from '../../core/util/client-loader.service';
import { resolvePublicAssetPath } from '../../core/util/client-path.util';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: "app-gestion-tramites",
  templateUrl: "./gestion-tramites.component.html",
  styleUrls: ["./gestion-tramites.component.css"],
})
export class GestionTramitesComponent extends UnsubscribeOnDestroy implements OnInit {
  gestionTramites = [];
  isLoggedIn = false;
  mensajeSpinner: string;
  private clientName = '';
  private rawCards: any[] = [];

  constructor(
    private tokenStorageService: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private router: Router,
    private _notificationI18n: NotificationI18nService,
    private spinner: NgxSpinnerService,
    private clientLoader: ClientLoaderService,
    private translate: TranslateService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    this.clientLoader.getClientName().then(name => {
      this.clientName = name;
      this.getCardTramite();
    });
  }

  getCardTramite() {
    this._servicioGeneral.getCardTramite()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.rawCards = this.filterCardsForClient(data['Cards'] || []);
        this.applyCardTranslations();
      },
      error: (error) => {
      },
    });
  }

  private applyCardTranslations(): void {
    this.gestionTramites = this.rawCards.map((card: any) => ({
      ...card,
      imagen: resolvePublicAssetPath(card.imagen),
      titleKey: `HOME.CARDS.${card.id}.TITLE`,
      descriptionKey: `HOME.CARDS.${card.id}.DESCRIPTION`,
      placeholderKey: card.type === 'input' ? `HOME.CARDS.${card.id}.PLACEHOLDER` : undefined,
      buttonKey: card.type === 'input' ? `HOME.CARDS.${card.id}.BUTTON` : undefined,
    }));
  }

  private filterCardsForClient(cards: any[]): any[] {
    if (this.clientName !== 'gmu') {
      return cards;
    }
    // GMU oculta "Crear un trámite" (3) y "Mis trámites" (30).
    // Comparar el número exacto: includes('action=3') también pillaba action=32.
    return cards.filter(card => {
      const url = card.url || '';
      const match = url.match(/[?&]action=(\d+)/);
      if (!match) {
        return true;
      }
      const action = Number(match[1]);
      return action !== 3 && action !== 30;
    });
  }

  /** Normaliza URLs antiguas (#/admin-emvs → #/perfil) para el href visible. */
  normalizeCardHref(url: string | null | undefined): string {
    if (!url) {
      return '#';
    }
    return this.rewriteLegacyCardUrl(url);
  }

  onRedirectCardClick(url: string | null | undefined, event: MouseEvent): void {
    if (!url) {
      return;
    }
    // Permitir abrir en pestaña nueva / middle-click.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    this.navigateCardUrl(url);
  }

  private navigateCardUrl(rawUrl: string): void {
    const url = this.rewriteLegacyCardUrl(rawUrl);
    // Ancla en inicio: #/inicio#region-tramites
    const hashIdx = url.indexOf('#', url.startsWith('#') ? 1 : 0);
    let routePart = url;
    let fragment: string | undefined;
    if (url.startsWith('#/') && hashIdx > 0) {
      routePart = url.substring(0, hashIdx);
      fragment = url.substring(hashIdx + 1);
    }
    const withoutHash = routePart.replace(/^#\/?/, '').replace(/^\//, '');
    const [path, queryString] = withoutHash.split('?');
    const queryParams: Record<string, string> = {};
    if (queryString) {
      new URLSearchParams(queryString).forEach((value, key) => {
        queryParams[key] = value;
      });
    }
    // action=1 = menú padre "Mis Notificaciones" (área genérica) → Comunicaciones
    if (queryParams['action'] === '1') {
      queryParams['action'] = '32';
    }
    this.router.navigate(['/' + path], {
      queryParams: Object.keys(queryParams).length ? queryParams : undefined,
      fragment
    });
  }

  private rewriteLegacyCardUrl(url: string): string {
    // Rutas antiguas de área de usuario (OV). No son del backoffice.
    // admin-emvs / admin-madrid-vivienda → perfil (única ruta en sgfront).
    let out = url
      .replace(/admin-emvs/g, 'perfil')
      .replace(/admin-madrid-vivienda/g, 'perfil')
      .replace(/admin-gmu/g, 'perfil');
    // Mis notificaciones antigua: action=1 → comunicaciones (32)
    out = out.replace(/([?&]action=)1(?!\d)/, '$132');
    return out;
  }

  setValue(event, index) {
    const formularioActual = this.gestionTramites[index];
    formularioActual["valor"] = event.target.value;
  }

  submitCardAction(action: string, index: number): void {
    this.doAction(
      action,
      index,
      this.translate.instant('HOME.GESTION.SPINNER.RECOVERING')
    );
  }

  doAction(action, index, message) {
    
    const formularioActual = this.gestionTramites[index];
    

    if (this.checkUserIsActive() && 
      formularioActual["valor"] &&
      (!formularioActual["loading"] || formularioActual["loading"] == false)
    ) {
      this.mostrarSpinnerMsg(message)
      formularioActual["loading"] = true;
      this._servicioGeneral
        .cardTramiteDoAction({
          action: action,
          value: formularioActual["valor"],
        })
        
          .pipe(takeUntil(this.destroy$))
          .subscribe({
          next: (response:any) => {
            if(response.message.status == '603' || (!response.documentob64 && !response.urlRedirect)){
              this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_HAN_ENCONTRADO_DOCUMENTOS_CON_ESE_CSV')
            }  
            else if (response.documentob64) {
              this.downloadPdf(response.documentob64, response.documento);              
            }
            else if (response.urlRedirect) {
              this.redirectUrl(response.urlRedirect);              
            }            
            formularioActual["loading"] = false;
            this.ocultarSpinner();
          },
          error: (error) => {
            this.ocultarSpinner()
            this._notificationI18n.error('NOTIFICATION.MESSAGE.HA_OCURRIDO_UN_ERROR_RECUPERANDO_EL_DOCUMENTO_CON_ESE_CSV')
            formularioActual["loading"] = false;
          },
        });
    }
  }
  redirectUrl(url) {
    window.open(url,'_blank');
  }
  public downloadPdf(base64Document, fileName) {
    if (base64Document) {
      const source = "data:application/pdf;base64," + base64Document;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}`;
      link.click();
    }
    this.ocultarSpinner()
  }

  checkUserIsActive():boolean {  
    let token = this.tokenStorageService.getToken();

    if (token != null) {
      var decodedToken: any = jwt_decode(token);
      var expired = Math.floor(new Date().getTime() / 1000) >= decodedToken.exp;
      if (expired) {
        this.tokenStorageService.signOutExpirationAndRedirectTo("login");
        window.location.reload();
        return false;
      }
    }else{
      this.router.navigate(["login"]);
      return false;
    }
    return true;
  }

  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('gestion_tramites_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('gestion_tramites_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('gestion_tramites_spinner');
  }
  navegaSeccion(ruta: string){
    this.router
    .navigate(["inicio"], { skipLocationChange: true })
    .then(() => {
      this.router.navigateByUrl('/'+ruta);
    });
  }
}
